// extracted by mini-css-extract-plugin
export default {"modalOverlay":"style_modalOverlay__MICWe","modal":"style_modal__0ghbd"};